import _defineProperty from "/app/node_modules/.pnpm/next@12.3.3_4afada721a4a39e35a1a66028f2134fd/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import axios from 'axios';
import { noop } from 'lodash';
import ApiClient, { interceptors } from 'libs/common/api-client';
import { navigateToPage } from 'libs/utils/window';
import { ResponseCode } from 'data/api/response-codes';
import { API_BASE_PATH } from 'constants/paths';
import { authenticateUserArgsToParams } from 'data/api/transformers/args';

const initSessionInterceptor = instance => instance.interceptors.response.use(async response => {
  var _response$data$auth_t;

  const token = response.data.access_token || ((_response$data$auth_t = response.data.auth_token) === null || _response$data$auth_t === void 0 ? void 0 : _response$data$auth_t.access_token);

  if (!token) {
    return Promise.reject(new Error('Token was not provided'));
  }

  try {
    const sessionResponse = await axios.get('/member/general/session_from_token', {
      headers: {
        Authorization: "Bearer ".concat(token)
      }
    }); // TODO: remove after PL merge

    if (sessionResponse.data && 'redirect_to' in sessionResponse.data && sessionResponse.data.redirect_to) {
      navigateToPage(sessionResponse.data.redirect_to); // Stopping further code execution

      return await new Promise(noop);
    }

    return response;
  } catch (exception) {
    exception.code = ResponseCode.SessionFromTokenError;
    return Promise.reject(exception);
  }
}, exception => {
  return Promise.reject(exception);
});

const api = new ApiClient({}, [interceptors.csrfTokenInterceptor, interceptors.errorInterceptor, interceptors.localeInterceptor, initSessionInterceptor]);
const ajaxApi = axios.create();
interceptors.csrfTokenInterceptor(ajaxApi);
export async function logoutUser() {
  try {
    const response = await ajaxApi.post('/member/general/logout');
    const isResponse2xx = "".concat(response.status).startsWith('2');
    return isResponse2xx;
  } catch (_unused) {
    return false;
  }
}
export function registerUser(args) {
  const {
    realName,
    login,
    email,
    password,
    agreeRules,
    referrerId,
    subscribeToNewsletter = false,
    fingerprint,
    uuid
  } = args;
  const user = {
    real_name: realName,
    login,
    email,
    password,
    agree_rules: agreeRules,
    user_settings: {
      is_newsletter_subscriber: subscribeToNewsletter
    }
  };
  return api.post("".concat(API_BASE_PATH, "/users"), {
    user,
    referrer_id: referrerId,
    fingerprint,
    uuid
  });
}
export function registerFacebookUser(args) {
  const {
    token,
    login,
    email,
    referrerId,
    subscribeToNewsletter = false,
    realName,
    fingerprint
  } = args;
  const user = {
    login,
    real_name: realName,
    email,
    user_setting: {
      is_newsletter_subscriber: subscribeToNewsletter
    }
  };
  return api.post("".concat(API_BASE_PATH, "/facebook_users"), {
    fb_access_token: token,
    user,
    referrer_id: referrerId,
    fingerprint
  });
}
export function registerGoogleUser(args) {
  const {
    token,
    login,
    email,
    referrerId,
    subscribeToNewsletter = false,
    realName,
    fingerprint
  } = args;
  const user = {
    login,
    real_name: realName,
    email,
    user_setting: {
      is_newsletter_subscriber: subscribeToNewsletter
    },
    referrer_id: referrerId
  };
  return api.post("".concat(API_BASE_PATH, "/google_user"), {
    id_token: token,
    user,
    fingerprint
  });
}
export function registerAppleUser(args) {
  const {
    token,
    login,
    email,
    referrerId,
    subscribeToNewsletter = false,
    realName,
    fingerprint
  } = args;
  const user = {
    login,
    real_name: realName,
    email,
    user_setting: {
      is_newsletter_subscriber: subscribeToNewsletter
    },
    referrer_id: referrerId
  };
  return api.post("".concat(API_BASE_PATH, "/apple_user"), {
    id_token: token,
    user,
    fingerprint
  });
}
export function authenticateUser(args) {
  return api.post('/oauth/token', _objectSpread({
    client_id: 'web',
    scope: 'user'
  }, authenticateUserArgsToParams(args)));
}
export function resetPassword(_ref) {
  let {
    email
  } = _ref;
  return api.post("".concat(API_BASE_PATH, "/users/reset_password"), {
    email
  });
}
export function generateRandomUser(args) {
  const {
    isGod
  } = args;
  return api.post("".concat(API_BASE_PATH, "/generate_random_user"), {
    is_god: isGod
  });
}